import { ComponentType } from "react";
import { Permissions } from "../../contexts/authorize.context";
import Category from "../../pages/Management/Category/Category";
import Company from "../../pages/Management/Company/Company";
import ConfigCategory from "../../pages/Management/ConfigCategory/ConfigCategory";
import EmissionFactor from "../../pages/Management/EmissionFactor/EmissionFactor";
import Transaction from "../../pages/Management/Transaction/Transaction";
import Unit from "../../pages/Management/Unit/Unit";
import { NavigateStateType } from "./NavigateState";
import { SnackbarProvider } from "../../contexts/snackbar.context";

export type ScreenType = "main" | "detail" | "create";

/**
 * 
    @type {AppRouter} - {RouterIcon}
    example:
    RouterIcon: ({ open }: RouterType) => (
        <ListItemIcon open={open}>
            <HomeIcon color="primary" />
        </ListItemIcon>
    ),
 */
export type AppRouter = NavigateStateType & {
    thumbsLabel?: string;
    to: string;
    path: string;
    RouterIcon?: ComponentType<RouterType>;
    testId: string;
    displayOnMenu?: boolean;
    Component: JSX.Element;
    permissions?: Permissions;
};

export type RouterType = {
    open?: boolean;
};

export const AppRouters: Array<AppRouter> = [
    {
        type: "management",
        modules: "transaction",
        screenType: "main",
        label: "Transaction",
        thumbsLabel: "Transaction",
        to: "/transaction",
        path: "/transaction",
        testId: "test-nav-transaction-mgt",
        displayOnMenu: true,
        Component: (
            <SnackbarProvider>
                <Transaction />
            </SnackbarProvider>
        ),
        permissions: ["GHMGT01001"],
    },
    {
        type: "management",
        modules: "emission-factor",
        screenType: "main",
        label: "Emission Factor",
        thumbsLabel: "Emission Factor",
        to: "/emission-factor",
        path: "/emission-factor",
        testId: "test-nav-emission-factor-mgt",
        displayOnMenu: true,
        Component: <EmissionFactor />,
        permissions: ["GHMGT02001"],
    },
    {
        type: "management",
        modules: "category",
        screenType: "main",
        label: "Category",
        thumbsLabel: "Category",
        to: "/category/config",
        path: "/category/config",
        testId: "test-nav-config-category-mgt",
        displayOnMenu: true,
        Component: <ConfigCategory />,
        permissions: ["GHMGT04001"],
    },
    {
        type: "management",
        modules: "company",
        screenType: "main",
        label: "Company",
        thumbsLabel: "Company",
        to: "/company",
        path: "/company",
        testId: "test-nav-company-mgt",
        displayOnMenu: true,
        Component: <Company />,
        permissions: ["GHMGT03001"],
    },
    {
        type: "management",
        modules: "category",
        screenType: "main",
        label: "Category (Admin)",
        thumbsLabel: "Category (Admin)",
        to: "/category",
        path: "/category",
        testId: "test-nav-category-mgt",
        displayOnMenu: true,
        Component: <Category />,
        permissions: ["GHMGT05001"],
    },
    {
        type: "management",
        modules: "unit",
        screenType: "main",
        label: "Unit",
        thumbsLabel: "Unit",
        to: "/unit",
        path: "/unit",
        testId: "test-nav-unit-mgt",
        displayOnMenu: true,
        Component: <Unit />,
        permissions: ["GHMGT06001"],
    },
];
const strCompareEqual = (a: string, b: string): boolean => a === b;
export const getAppRouter = (navigateStateType: NavigateStateType) => {
    return AppRouters.find(
        ({ type, screenType, modules }) =>
            strCompareEqual(type, navigateStateType.type) &&
            strCompareEqual(screenType, navigateStateType.screenType) &&
            strCompareEqual(modules, navigateStateType.modules)
    );
};
export const getAppRouterPath = (navigateStateType: NavigateStateType) => {
    const appRouter: AppRouter | undefined = getAppRouter(navigateStateType);
    if (!appRouter) throw new Error("AppRouter not found, Hint recheck navigate state type and AppRouters.");
    return appRouter.path;
};
